import { useSearchParams } from "react-router-dom";
import { getAuthUrl, getLogoutUrl } from "../config/auth";
import { resetSsoRedirects } from "../utils/authLoopGuard";

const MESSAGES: Record<string, { title: string; text: string }> = {
  forbidden: {
    title: "Account non abilitato",
    text: "Il tuo account è autenticato ma non è abilitato all'uso del portale (stato diverso da attivo). Contatta l'amministratore.",
  },
  rate: {
    title: "Troppi tentativi",
    text: "Sono stati effettuati troppi tentativi di accesso in poco tempo. Attendi circa un minuto e riprova.",
  },
  loop: {
    title: "Accesso non riuscito",
    text: "Non è stato possibile completare l'accesso: la sessione è stata rifiutata più volte di seguito. Esci e riprova; se il problema continua contatta l'amministratore.",
  },
};

export default function AuthError() {
  const [params] = useSearchParams();
  const msg = MESSAGES[params.get("reason") ?? ""] ?? MESSAGES.loop;

  const retry = () => {
    resetSsoRedirects();
    window.location.href = getAuthUrl();
  };
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    resetSsoRedirects();
    window.location.href = getLogoutUrl();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 font-body text-neutral-600">
      <div className="w-full max-w-lg rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <h1 className="mb-3 text-3xl font-bold text-blue-600">{msg.title}</h1>
        <p className="mb-8 text-base text-gray-600">{msg.text}</p>
        <div className="flex justify-center gap-3">
          <button type="button" onClick={retry} className="bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-700">
            Riprova
          </button>
          <button type="button" onClick={logout} className="border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-100">
            Esci
          </button>
        </div>
      </div>
    </div>
  );
}
